import PostAuthor from '@/domain/Blog/PostAuthor';

export default function PostTrainer({ trainer }) {
  return (
    <div className="pt-5">
      <PostAuthor trainer={trainer} position="Entrenador" />
    </div>
  );
}
